module.exports = __webpack_public_path__ + "static/media/description.59213515.md";